// Temporarily commented out - restore when done with spike testing
// import { Providers } from './app/providers';
//import { UppySpike } from './features/upload-spike/UppySpike';

import {Providers} from "@/app/providers";

export function App() {
  // Temporarily using UppySpike for testing - restore Providers when done
  // return <UppySpike />;
  return <Providers />;
}
